import React from "react";
import Nav from "@/components/portfolio/Nav";
import Hero from "@/components/portfolio/Hero";
import Metrics from "@/components/portfolio/Metrics";
import Experience from "@/components/portfolio/Experience";
import CaseStudies from "@/components/portfolio/CaseStudies";
import Clients from "@/components/portfolio/Clients";
import Skills from "@/components/portfolio/Skills";
import Contact from "@/components/portfolio/Contact";
import Footer from "@/components/portfolio/Footer";

export default function Portfolio() {
    return (
        <main
            data-testid="portfolio-root"
            className="min-h-screen bg-[#f7f5f1] text-[#0e0e0c]"
        >
            <Nav />
            <Hero />
            <Metrics />
            <Experience />
            <CaseStudies />
            <Clients />
            <Skills />
            <Contact />
            <Footer />
        </main>
    );
}
